module.exports = __webpack_public_path__ + "media/packs/images/flags/AW-ab7525d1111ac194e90b77124b58479b.png";